import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'appUcWords'
})
export class UcWordPipe implements PipeTransform {

  transform(value: string): string {
    if (value == null) {
      return '';
    }

    const _tmp = value.toLowerCase().split(' ');
    for (let x = 0; x < _tmp.length; x++) {
      _tmp[x] = _tmp[x][0].toUpperCase() + _tmp[x].substr(1, _tmp[x].length);
    }

    return _tmp.join(' ');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/pipes/uc-words/uc-words.pipe.ts